// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L4xG","field":"styles_field__2nyQZ","fieldCol":"styles_fieldCol__FlxPF","diffCol":"styles_diffCol__1Z2ZV","diff":"styles_diff__2eCNh"};